var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var space = {
    none: '0px',
    xxs: '2px',
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
    xxxl: '64px'
};
var breakpoints = {
    mobile: '0em',
    tablet: '48em',
    desktop: '62em',
    smallscreen: '64.0625em' //1025px
};
var fontFamilies = {
    default: "'sofia-pro', -apple-system, 'Segoe UI', Roboto, 'Open Sans', sans-serif",
    heading: "'sofia-pro', -apple-system, 'Segoe UI', Roboto, 'Open Sans', sans-serif",
    mono: 'monospace'
};
var fontSizes = {
    caption: '.75rem',
    control: '.875rem',
    content: '1rem',
    heading6: '1.25rem',
    heading5: '1.5rem',
    heading4: '1.75rem',
    heading3: '2rem',
    heading2: '2.5rem',
    heading1: '4rem'
};
var fontWeights = {
    light: 200,
    regular: 400,
    medium: 500,
    bold: 700
};
var lineHeights = {
    regular: 1.5,
    heading: 1.25,
    control: 1.375
};
var typography = {
    caption: {
        fontFamily: fontFamilies.default,
        fontSize: fontSizes.caption,
        lineHeight: lineHeights.regular,
        fontWeight: fontWeights.regular
    },
    control: {
        fontFamily: fontFamilies.default,
        fontSize: fontSizes.control,
        lineHeight: lineHeights.control,
        fontWeight: fontWeights.regular
    },
    content: {
        fontFamily: fontFamilies.default,
        fontSize: fontSizes.content,
        lineHeight: lineHeights.regular,
        fontWeight: fontWeights.regular
    },
    heading6: {
        fontFamily: fontFamilies.heading,
        fontSize: fontSizes.heading6,
        lineHeight: lineHeights.heading,
        fontWeight: fontWeights.bold
    },
    heading5: {
        fontFamily: fontFamilies.heading,
        fontSize: fontSizes.heading5,
        lineHeight: lineHeights.heading,
        fontWeight: fontWeights.bold
    },
    heading4: {
        fontFamily: fontFamilies.heading,
        fontSize: fontSizes.heading4,
        lineHeight: lineHeights.heading,
        fontWeight: fontWeights.bold
    },
    heading3: {
        fontFamily: fontFamilies.heading,
        fontSize: fontSizes.heading3,
        lineHeight: lineHeights.heading,
        fontWeight: fontWeights.bold
    },
    heading2: {
        fontFamily: fontFamilies.heading,
        fontSize: fontSizes.heading2,
        lineHeight: lineHeights.heading,
        fontWeight: fontWeights.bold
    },
    heading1: {
        fontFamily: fontFamilies.heading,
        fontSize: fontSizes.heading1,
        lineHeight: lineHeights.heading,
        fontWeight: fontWeights.bold
    }
};
var textStyle = {
    caps: {
        textTransform: 'uppercase'
    }
};
var paletteColors = {
    primary: '#0F0D08',
    secondary: '#1E70DD',
    success: '#0A8A00',
    danger: '#DC2222',
    warning: '#FFCC5D',
    disabled: '#EEEEEE'
};
var colors = __assign(__assign({}, paletteColors), { amethyst200: '#DFE0FF', amethyst400: '#BFC2FF', amethyst500: '#7F85FF', amethyst600: '#686BC0', citrine200: '#FFF7D1', citrine400: '#FFEEA4', citrine500: '#FFDE49', citrine600: '#E7C842', danger100: '#FFF5F5', danger400: '#FF5B5B', danger500: paletteColors.danger, danger600: '#B00000', emerald200: '#C4F7E4', emerald400: '#8AEEC9', emerald500: '#15DE93', emerald600: '#00BD7F', gray100: '#F8F8F8', gray200: paletteColors.disabled, gray300: '#E0E0E0', gray400: '#D1D1D1', gray500: '#BDBDBD', gray600: '#9E9E9E', gray700: '#767676', gray800: '#616161', gray900: '#353431', opacity: 'rgba(222,222,222,0.5)', opacityDark: 'rgba(55,55,55,0.8)', opacityLight: 'rgba(222,222,222,0.2)', opacityShadow: 'rgba(0,0,0,0.1)', peridot200: '#E5F7DA', peridot400: '#CBEEB4', peridot500: '#98DE6A', peridot600: '#86BD58', primary500: paletteColors.primary, red: 'red', ruby200: '#FFD3D7', ruby400: '#FFA8AF', ruby500: '#FF5160', ruby600: '#C0434D', secondary100: '#F4F8FD', secondary200: '#BADEFF', secondary400: '#1791FF', secondary500: paletteColors.secondary, secondary600: '#144E9A', secondary700: '#002F6D', success100: '#F1FAF2', success400: '#51BB3D', success500: paletteColors.success, success600: '#086D00', topaz200: '#FFE8D4', topaz400: '#FFD1A8', topaz500: '#FFA452', topaz600: '#DC8D46', turquoise200: '#D2F4F6', turquoise400: '#A5E9EE', turquoise500: '#4CD4DD', turquoise600: '#3FACB2', warning100: '#FFF8EB', warning400: '#FFDF9E', warning500: paletteColors.warning, warning600: '#EFB422', warning800: '#613E11', white: '#FFFFFF' });
var borders = {
    none: 0,
    regular: "1px solid " + colors.gray300,
    thick: "2px solid " + colors.gray300
};
var radii = {
    none: '0px',
    xs: '1px',
    sm: '2px',
    md: '6px',
    lg: '12px',
    xl: '24px',
    rounded: '100%',
    inherit: 'inherit'
};
var opacities = {
    disabled: 0.7
};
var transitions = {
    slow: '0.7s ease',
    fast: '0.3s ease',
    duration: {
        slow: '0.7s',
        fast: '0.3s',
        superFast: '0.1s',
        none: '0s'
    }
};
var shadows = {
    none: 'none',
    inset: 'inset 0px 11px 8px -10px rgba(0,0,0,0.12)',
    xs: '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
    sm: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    md: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    lg: '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    xl: '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)'
};
var sizes = {
    xs: '24em',
    sm: '30em',
    md: '42em',
    lg: '60em'
};
var zIndices = {
    footer: 1,
    notification: 4,
    formActions: 10,
    selectMenu: 100,
    header: 1000,
    modal: 1000,
    tooltip: 2000
};
var template = 'LUCID';
/**
 * Theme variables for Lucid applications
 */
export var LucidTheme = {
    template: template,
    fontWeights: fontWeights,
    fontFamilies: fontFamilies,
    lineHeights: lineHeights,
    fontSizes: fontSizes,
    space: space,
    breakpoints: breakpoints,
    borders: borders,
    radii: radii,
    typography: typography,
    colors: colors,
    opacities: opacities,
    transitions: transitions,
    shadows: shadows,
    textStyle: textStyle,
    zIndices: zIndices,
    sizes: sizes
};
//# sourceMappingURL=index.js.map